import { Theme } from '@chakra-ui/react'

function getAccessibilityGlobalCSS(theme: Theme, isLightMode: boolean) {
  const boxShadowFocusColor = theme.colors.blue[isLightMode ? 400 : 200]

  return {
    '.accessible': {
      rounded: 'md',
      cursor: 'pointer',
      transition: 'all 250ms',
      outline: 'none',
      _focus: {
        border: 'none !important',
        boxShadow: `0 0 0 3px ${boxShadowFocusColor}`,
      },
    },
    '.accessible-with-border': {
      rounded: 'md',
      cursor: 'pointer',
      transition: 'all 250ms',
      outline: 'none',
      _focus: {
        boxShadow: `0 0 0 3px ${boxShadowFocusColor}`,
      },
    },

    '.clicable': {
      cursor: 'pointer',
      transition: 'all 250ms',
    },

    '.tr-accessible': {
      cursor: 'pointer',
      transition: 'all 250ms',
      outline: 'none',
      _hover: {
        bg: 'lighterPrimary',
      },
      _focus: {
        bg: 'lighterPrimary',
      },
    },
  }
}

export default getAccessibilityGlobalCSS
